import { Violation } from "../interfaces/Violation.interface";
import { AppConfig } from "../services/app.config.services";

export const FormatViolationDateTime = (violationInfo: Violation) => {
    //There is a possibility that the ViolationDateTime received by server can be in local time or UTC time based on the TRS_UTC_TIME env variable configured in the UI
    //When displaying the datetime in UI, following scenarios are possible
    //  1. In TRS UI, TRS_UTC_TIME is set to true or if the variable is not set at all. This means TRS will send UTC time. For this in supervisor UI based on the ConvertToLocalTime configuration:
    //     a. Supervisor UI can show the UTC time as it is
    //     b. Supervisor UI has to show the local time by converting the UTC time received to local
    //  2. In TRS UI, TRS_UTC_TIME is set to false. This means TRS will send local time. For this in supervisor UI based on the ConvertToLocalTime configuration:
    //     a. Supervisor UI can show the local time as it is
    //     b. Supervisor UI has to show the UTC time by converting the local time received to UTC (This scenario is highly unlikely)

    //Currently supervisor ui has no way to determine if the datetime received by TRS UI is local time or UTC time

    //In this commit done in TRS https://git.tetherfi.com:1443/tetherfi_product/products/trs/-/commit/be1992dbafb3471fc4608c1bf7faa881c2fe7441
    //The datetime in violations will come in this format yyyy-MM-dd HH:mm:ss from server, example 2022-12-01T14:48:27
    //Prior to this datetime in violations used to come in a different format sometimes with/without Z
    //Both the scenarios need to be handled and this is done through regex matching
    //For the new format i.e. yyyy-MM-dd HH:mm:ss we dont need to check if it includes Z

    if (violationInfo.ViolationDateTime != null) {
        const isDateTimeFormatNew: boolean = violationInfo.ViolationDateTime.toString().match(/^[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}$/) == null ? false : true;
        //Store the existing date in a new property ViolationUTCDateTime
        violationInfo.ViolationUTCDateTime = parseUtcCorrectly(violationInfo.ViolationDateTime);

        if (isDateTimeFormatNew === false) {
            //This is the old logic
            if (AppConfig.settings.defaults.DateTimeSettings.ConvertShowChatEventHistoryToLocal === false) {
                //If UTC time is to be shown in the UI
                if (violationInfo.ViolationDateTime.toString().includes('Z') == false)
                    violationInfo.ViolationDateTime = new Date(violationInfo.ViolationDateTime);
            }
            else {
                //show in local time format
                if (violationInfo.ViolationDateTime.toString().includes('Z') == false)
                    violationInfo.ViolationDateTime = new Date(violationInfo.ViolationDateTime + 'Z');
                else {
                    if (violationInfo.ViolationName == 'Session Logoff')
                        violationInfo.ViolationDateTime = violationInfo.ViolationDateTime;
                    else violationInfo.ViolationDateTime = new Date(violationInfo.ViolationDateTime);
                }
            }
        }
        else violationInfo.ViolationDateTime = getConvertedDateTime(violationInfo.ViolationDateTime);
    }
}

const parseUtcCorrectly = (raw: string | Date): Date => {
    const str = raw.toString().trim();

    if (str.endsWith("Z")) {
        // already proper ISO UTC
        return new Date(str);
    }

    // format is always: yyyy-MM-ddTHH:mm:ss (without Z)
    const [datePart, timePart] = str.split("T");
    const [y, m, d] = datePart.split("-").map(Number);
    const [hh, mm, ss] = timePart.split(":").map(Number);

    // Build as actual UTC without letting JS assume it's local
    return new Date(Date.UTC(y, m - 1, d, hh, mm, ss));
}

export const getUTCDateObj = (): Date => new Date();

export const getFormattedDateTime = (isUTC: boolean): string => {
    const date: Date = new Date();

    if (isUTC === true)
        return `${`00${date.getUTCMonth() + 1}`.slice(-2)}/${`00${date.getUTCDate()}`.slice(-2)}/${date.getUTCFullYear()} ${`00${date.getUTCHours()}`.slice(-2)}:${`00${date.getUTCMinutes()}`.slice(-2)}:${`00${date.getUTCSeconds()}`.slice(-2)}`;
    else return `${`00${date.getMonth() + 1}`.slice(-2)}/${`00${date.getDate()}`.slice(-2)}/${date.getFullYear()} ${`00${date.getHours()}`.slice(-2)}:${`00${date.getMinutes()}`.slice(-2)}:${`00${date.getSeconds()}`.slice(-2)}`;
}

export const getConvertedDateTime = (dateTime: string | Date): Date => {
    const convertToLocal: boolean = AppConfig.settings.defaults.DateTimeSettings.ConvertShowChatEventHistoryToLocal;

    if (convertToLocal == false)
        return new Date(dateTime.toString());

    //Server is sending datetime in UTC format
    const utc = parseUtcCorrectly(dateTime);
    return new Date(utc.getTime());
}